<template>
  <div>
    <b-row class="mb-5" align-v="center">
      <b-col>
        <h4>Observações da entrevista inicial</h4>
      </b-col>
      <b-col cols="auto" v-if="canEdit">
        <div
          class="d-flex flex-row flex-nowrap text-nowrap"
          style="gap: 10px"
          v-if="initialInterview && initialInterview.initial_interview"
        >
          <b-button class="btn medium blue" @click="openModal()">
            Atualizar registro
          </b-button>
          <b-button
            class="btn medium outline"
            @click="deleteInitialInterview"
          >
            Excluir registro
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="initialInterview && initialInterview.initial_interview">
      <b-col>
        <div class="interview-content">
          <i class="interview-meta">
            <strong>{{ interviewCreator }}</strong>
            <time>• {{ initialInterview.updated_at }}</time>
          </i>
          <p style="white-space: pre-line">
            {{ initialInterview.initial_interview }}
          </p>

          <div class="files-container" v-if="initialInterview.file_url">
            <div class="file-item">
              <a
                :href="initialInterview.file_url"
                target="_blank"
                class="file-link"
              >
                <b-icon icon="file-arrow-down" aria-hidden="true"></b-icon>
                <span>Anexo</span>
              </a>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="!initialInterview || !initialInterview.initial_interview"
      class="box-not-found"
    >
      <b-col>
        <div class="message-not-found">
          <p>Ainda não existe entrevista registrada para esse aluno.</p>
          <b-button
            v-if="canEdit"
            class="btn medium blue mt-3"
            @click="$bvModal.show('modal-create-initialView')"
          >
            Inserir registro
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="student">
      <b-col class="parent-list">
        <h4 class="mb-4">Responsáveis</h4>
        <ul>
          <li
            v-if="
              student.Parent1 &&
              student.Parent1.Responsible &&
              student.Parent1.Responsible.User
            "
          >
            <div>
              <b-avatar
                class="mb-4"
                :src="
                  student.Parent1.Responsible.User.photo
                    ? student.Parent1.Responsible.User.photo
                    : '../../../assets/images/user_placeholder.png'
                "
                size="10rem"
              ></b-avatar>
            </div>
            <div>
              <p>
                <b>{{
                  student.Parent1.Responsible.User.name
                    ? student.Parent1.Responsible.User.name
                    : "Não cadastrado"
                }}</b>
              </p>
              <p>
                <b>Profissão: </b
                >{{
                  student.Parent1.Responsible.profession
                    ? student.Parent1.Responsible.profession
                    : "Não cadastrado"
                }}
              </p>
              <p>
                <b>Contato: </b>
                <span>
                  {{
                    student.Parent1.Responsible.User.Phones.length > 0
                      ? student.Parent1.Responsible.User.Phones[0].number
                      : "Não cadastrado"
                  }}
                </span>
              </p>
            </div>
          </li>
          <li
            v-if="
              student.Parent2 &&
              student.Parent2.Responsible &&
              student.Parent2.Responsible.User
            "
          >
            <div>
              <b-avatar
                class="mb-4"
                :src="
                  student.Parent2.Responsible.User.photo
                    ? student.Parent2.Responsible.User.photo
                    : '../../../assets/images/user_placeholder.png'
                "
                size="10rem"
              ></b-avatar>
            </div>
            <div>
              <p>
                <b>{{
                  student.Parent2.Responsible.User.name
                    ? student.Parent2.Responsible.User.name
                    : "Não cadastrado"
                }}</b>
              </p>
              <p>
                <b>Profissão: </b
                >{{
                  student.Parent2.Responsible.profession
                    ? student.Parent2.Responsible.profession
                    : "Não cadastrado"
                }}
              </p>
              <p>
                <b>Contato: </b
                >{{
                  student.Parent2.Responsible.User.Phones.length > 0
                    ? student.Parent2.Responsible.User.Phones[0].number
                    : "Não cadastrado"
                }}
              </p>
            </div>
          </li>
        </ul>
      </b-col>
    </b-row>

    <b-modal
      id="modal-update-initialView"
      v-if="this.initialInterview"
      hide-footer
    >
      <template #modal-title>Atualizar entrevista de entrada</template>
      <div class="d-block text-center">
        <b-form>
          <b-form-group
            id="modal-form-observation"
            label="Escrever comentário"
            label-for="form-observation"
          >
            <b-form-textarea
              id="form-observation"
              v-model="initialInterview.initial_interview"
              type="textarea"
              placeholder=""
              required
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <UploadFiles
              v-model="initialInterview.file_url"
              :fileName="initialInterview.file_url ? 'Anexo' : null"
            />
          </b-form-group>
          <b-form-group class="wrap-btn-form">
            <b-button @click="updateInitialInterview" class="btn middle blue">
              Atualizar
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>

    <!-- Modal de criação -->
    <b-modal
      id="modal-create-initialView"
      hide-footer
      @show="resetNewInterview"
    >
      <template #modal-title>Registrar entrevista de entrada</template>
      <div class="d-block text-center">
        <b-form>
          <b-form-group
            id="modal-form-observation-create"
            label="Escrever comentário"
            label-for="form-observation-create"
          >
            <b-form-textarea
              id="form-observation-create"
              v-model="newInterview.initial_interview"
              type="textarea"
              placeholder=""
              required
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <UploadFiles v-model="newInterview.file_url" :fileName="files" />
          </b-form-group>
          <b-form-group class="wrap-btn-form">
            <b-button @click="sendInitialInterview" class="btn middle blue">
              Registrar
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import UploadFiles from "@/components/inputs/UploadFiles.vue";
import moment from "moment";
import httpRda from "../http-rda";
import store from "../store";

export default {
  name: "InitialInterviewTab",
  components: {
    UploadFiles,
  },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      student: null,
      initialInterview: {
        initial_interview: null,
        file_url: null,
        who_edited_id: null,
        name: null,
        student_id: null,
        id: null,
      },
      newInterview: {
        initial_interview: null,
        file_url: null,
      },
      currentUserId: null,
      files: null,
      loading: false,
    };
  },
  methods: {
    openModal() {
      this.$bvModal.show("modal-update-initialView");
    },

    async loadStudentData() {
      try {
        this.loading = true;

        const studentResponse = await httpRda.get(
          `students/${this.studentId}/parents-basic-data`
        );
        this.student = studentResponse.data.student;

        await this.loadInitialInterview();

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async loadInitialInterview() {
      try {
        const response = await httpRda.get(
          `students/${this.studentId}/initial-interview`
        );

        const interviewData = response.data.result;

        if (interviewData && interviewData.initial_interview) {
          this.initialInterview = {
            ...interviewData,
            created_at: moment(interviewData.created_at)
              .subtract(3, "hours")
              .format("DD/MM/YYYY [às] HH:mm"),
            updated_at: moment(interviewData.updated_at)
              .subtract(3, "hours")
              .format("DD/MM/YYYY [às] HH:mm"),
          };
        } else {
          this.initialInterview = {
            initial_interview: null,
            file_url: null,
            who_edited_id: null,
            name: null,
            student_id: null,
            id: null,
          };
        }
      } catch (error) {
        this.initialInterview = {
          initial_interview: null,
          file_url: null,
          who_edited_id: null,
          name: null,
          student_id: null,
          id: null,
        };
      }
    },

    resetNewInterview() {
      this.newInterview = {
        initial_interview: null,
        file_url: null,
      };
    },

    async sendInitialInterview() {
      try {
        const formData = new FormData();
        formData.append(
          "initial_interview",
          this.newInterview.initial_interview
        );
        formData.append("who_edited_id", this.currentUserId);
        formData.append("student_id", this.studentId);
        formData.append("file", this.newInterview.file_url);

        if (!this.newInterview.initial_interview) {
          this.$swal.fire({
            title: "Alerta",
            text: "A entrevista não pode ser vazia",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          await httpRda.post(
            `students/${this.studentId}/initial-interview`,
            formData
          );
          this.$swal.fire({
            title: "Sucesso",
            text: "Entrevista registrada com sucesso.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });

          this.$bvModal.hide("modal-update-initialView");
          this.$bvModal.hide("modal-create-initialView");

          this.resetNewInterview();

          await this.loadInitialInterview();

          this.$emit("interview-updated");
        }
      } catch (err) {
        this.$swal.fire({
          title: "Alerta",
          text: err.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    async updateInitialInterview() {
      try {
        const formData = new FormData();

        formData.append(
          "initial_interview",
          this.initialInterview.initial_interview
        );
        formData.append("who_edited_id", this.currentUserId);
        formData.append("file", this.initialInterview.file_url);

        if (!this.initialInterview.initial_interview) {
          this.$swal.fire({
            title: "Alerta",
            text: "A entrevista não pode ser vazia",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          await httpRda.patch(
            `students/${this.studentId}/initial-interview/${this.initialInterview.id}`,
            formData
          );

          this.$swal.fire({
            title: "Sucesso",
            text: "Entrevista atualizada com sucesso.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });

          this.$bvModal.hide("modal-update-initialView");
          this.$bvModal.hide("modal-create-initialView");

          await this.loadInitialInterview();

          this.$emit("interview-updated");
        }
      } catch (err) {
        this.$swal.fire({
          title: "Alerta",
          text: err.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    async deleteInitialInterview() {
      const result = await this.$swal.fire({
        title: "Tem certeza?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#68c5b7",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        await httpRda.delete(
          `students/${this.studentId}/initial-interview/${this.initialInterview.id}`
        );

        this.$swal.fire({
          title: "Excluído!",
          text: "Entrevista excluída com sucesso.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });

        await this.loadInitialInterview();

        this.$emit("interview-updated");
      } catch (err) {
        this.$swal.fire({
          title: "Erro!",
          text: err.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    getCurrentUser() {
      const authData = store.getters["auth/getAuthData"];
      this.currentUserId = authData.id;
    },
  },

  async mounted() {
    this.getCurrentUser();
    await this.loadStudentData();
  },

  watch: {
    studentId: {
      immediate: false,
      async handler(newValue) {
        if (newValue) {
          await this.loadStudentData();
        }
      },
    },
  },

  computed: {
    interviewCreator() {
      if (this.initialInterview.who_edited_id === this.currentUserId) {
        return "Por mim";
      }
      if (this.initialInterview.user_id === this.currentUserId) {
        return "Por mim";
      }
      if (this.initialInterview.editor_name) {
        return this.initialInterview.editor_name;
      } else if (this.initialInterview.creator_name) {
        return this.initialInterview.creator_name;
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.interview-content {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 20px;
  background: #fafafa;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  margin-bottom: 30px;

  .interview-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    font-style: normal;
    font-size: 14px;
    color: #666666;
    margin-bottom: 8px;

    strong {
      color: #333;
      font-weight: 600;
    }

    time {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }

  p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
  }

  .files-container {
    display: flex;
    gap: 8px;
    margin-top: 12px;

    .file-item {
      .file-link {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 12px;
        background: #fff;
        border: 1px solid #e9e9e9;
        border-radius: 6px;
        text-decoration: none;
        color: #333;
        cursor: pointer;
        transition: 0.2s all ease-in-out;

        &:hover {
          box-shadow: 3px 3px 0 rgba(0, 0, 0, 0.1);
          transform: translate(-3px, -3px);
        }

        span {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          max-width: 200px;
        }
      }
    }
  }
}

.box-not-found {
  display: flex;
  flex-direction: row;
  justify-content: center;
  widows: 100%;
}

.message-not-found {
  width: 100%;
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  box-sizing: border-box;
  list-style: none;
  margin-bottom: 20px;

  p {
    margin: 0;
    color: #666666;
    font-size: 16px;
  }

  .btn {
    margin: 0 auto;
  }
}

.parent-list {
  ul {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 24px;
      list-style: none;

      p {
        margin-bottom: 0;
      }
    }
  }
}

.wrap-btn-form {
  width: 100%;
  border-bottom: 1px solid #b3b3b3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 0;
  margin-bottom: 24px;
  box-sizing: border-box;

  button {
    width: 146px;
  }
}
</style>
